<template>
  <a-form-item :label="field.name">
    <a-select
      show-search
      mode="multiple"
      label-in-value
      placeholder="Chọn người dùng"
      style="width: 100%;"
      :value="valueConverted"
      :filter-option="false"
      :not-found-content="fetching ? undefined : null"
      @search="fetchUser"
      @change="onChange"
      :maxTagCount="10"
      :labelInValue="labelInValue"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-icon slot="suffixIcon" type="user" />
      <a-select-option v-for="d in data" :key="d.id">
        <b v-text="d.fullname || d.username"></b><br />
        <span v-text="d.email"></span>
      </a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
import debounce from "lodash/debounce";
import gql from "graphql-tag";

const userType = `{
      id
      fullname
      username
      email
      initialsAvatar
    }`;

const userQuery = gql`
  query users($query: String) {
    users(query: $query) ${userType}
  }
`;
const userByIds = gql`
  query getUserByIds($ids: [ID!]!) {
    getUserByIds(ids: $ids) ${userType}
  }
`;
export default {
  props: {
    field: {
      type: Object,
      required: true
    },
    value: [Array, String]
  },
  data() {
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    return {
      data: [],
      fetching: false,
      labelInValue: false,
      valueConverted: undefined
    };
  },
  methods: {
    onChange(eventData) {
      this.$emit("input", eventData);
      this.fetching = false;
      // if (typeof eventData === "string") {
      // } else {
      //   this.$emit("input", JSON.stringify(eventData));
      // }
    },
    fetchUser(value) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.data = [];
      this.fetching = true;

      this.$apollo
        .query({
          query: userQuery,
          variables: { query: value }
        })
        .then(body => {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
          }
          this.data = body.data?.users;
          this.fetching = false;
        })
        .catch(error => {
          console.log("Lỗi lấy ds user", error);
        });
    },
    convertValue(val, isOnInit = false) {
      if (val && typeof val === "string") {
        const userIds = JSON.parse(val);
        this.valueConverted = userIds;

        // Chỉ chạy hàm khi khởi tạo
        if (isOnInit) {
          this.getUserByIds(userIds)
            .then(({ data }) => {
              if (data.getUserByIds?.length > 0) {
                this.data = [...this.data, ...data.getUserByIds];
              }
            })
            .catch(error => {
              console.log("Lỗi khi lấy dữ liệu", error);
            });
        }
      } else {
        this.valueConverted = val || [];
      }
    },
    getUserByIds(ids) {
      return this.$apollo.query({
        query: userByIds,
        variables: { ids }
      });
    }
  },
  watch: {
    value(val) {
      this.convertValue(val);
    }
  },
  created() {
    this.convertValue(this.value, true);
  }
};
</script>
